import type { Moment } from '@common/services/datetime';

import { DisputeStateType } from '@common/graphql';
import { gql } from '@common/hooks';
import {
  InvoiceItemListFragment,
  InvoiceItemListFragmentType,
} from '@pay-bill/graphql/fragments';

export const InvoiceItemsFiltersQuery = gql`
  query InvoiceItemsFilters(
    $entityId: ID!
    $entityType: WorksInvoiceItemsFilterEntity!
  ) {
    values: worksInvoiceItemsFilters(
      entityId: $entityId
      entityType: $entityType
    ) {
      disputeStates
      transactionIds
    }
  }
`;

export type InvoiceItemsFiltersQueryArgs = {
  entityId: string;
  entityType: 'invoice' | 'reverse_invoice';
};

export type InvoiceItemsFiltersQueryResponse = {
  values: {
    disputeStates: DisputeStateType[];
    transactionIds: string[];
  };
};

export const PaginatedInvItemsListQuery = gql`
  query PaginatedInvItemsList(
    $entityId: ID!
    $entityType: WorksInvoiceItemsFilterEntity!
    $page: PaginatedWorksInvoiceItemsPageInput!
    $filters: PaginatedWorksInvoiceItemsFilterInput
  ) {
    page: paginatedWorksInvoiceItems(
      entityId: $entityId
      entityType: $entityType
      page: $page
      filters: $filters
    ) {
      totalCount
      items: worksInvoiceItems {
        ...InvoiceItemListFragment
      }
    }
  }
  ${InvoiceItemListFragment}
`;

export type PaginatedInvItemsListQueryArgs = {
  entityId: string;
  entityType: 'invoice' | 'reverse_invoice';
  page: {
    limit: number;
    offset: number;
    orderDirection: 'ASC' | 'DESC';
    orderField:
      | 'BILLING_AMOUNT'
      | 'DATE'
      | 'DISPUTE_STATUS'
      | 'FULL_NAME'
      | 'HOURS'
      | 'ID'
      | 'EMPLOYEE_ID'
      | 'TRANSACTION_ID'
      | 'TRANSACTION_ID_INDICATOR'
      | 'PAY_CODE'
      | 'RATE'
      | 'SUPPLIER'
      | 'COST_ID';
  };
  filters: {
    disputeStatus?: string[];
    fullName?: string[];
    employeeId?: string[];
    payCode?: string[];
    date?: (string | Moment)[];
    hours?: number[];
    transactionId?: string[];
    availableAction?: ('view_dispute' | 'submit_dispute' | 'none')[];
    supplier?: string[];
    costId?: string[];
  };
};

export type PaginatedInvItemsListQueryResponse = {
  page: {
    totalCount: number;
    items: InvoiceItemListFragmentType[];
  };
};

export const InvoiceItemQuery = gql`
  query GetWorksInvoiceItem($id: String!) {
    worksInvoiceItem(id: $id) {
      id
      date
      staffingRequestType
      payCode
      hours
      totalSeconds
      effectiveHourlyRateCents
      worksInvoice {
        id
        preCalculated
      }
      worksReverseInvoice {
        id
        code
      }
      organization {
        id
        name
        payCodes
      }
      staffingRequestAssignment {
        id
      }
      worksProfile {
        id
        fullName
      }
    }
  }
`;
